import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import OrderPage from '../components/OrderPage';

class OrderOfDelegate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      delegateId: this.props.delegateId
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.delegateId !== this.props.delegateId) {
        this.setState({
            delegateId: nextProps.delegateId
        }, () => {
            this.refresh()
        })
    }
  }

  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.delegateSites(
          {
            delegateId: this.state.delegateId
          },
          {
            success: callback
          }
        )
      },
      fetchOrders: (params, callback) => {
        DataFetcher.delegateOrders(
          {
            ...params,
            delegateId: this.state.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      sendGift: (params, callback, completed) => {
        DataFetcher.delegateGift(
          {
            ...params,
            delegateId: this.state.delegateId
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      refund: (params, callback) => {
        DataFetcher.delegateRefund(
          {
            ...params,
            delegateId: this.state.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      delegateProfile: (params, callback) => {
        DataFetcher.delegateProfile(
          {
            ...params,
            id: this.state.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      bindRefreshFunc: (func) => {
        this.refresh = func
      }
    }

    return <OrderPage {...pageProps}/>
  }
}

export default OrderOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/OrderOfDelegate.js